import ClipboardJs from 'clipboard';
import { GameClient } from '../../gameClient/gameClient';
import { OnErrorCommand } from '../../gameClient/clientCommands/onErrorCommand';
import { WebCommands } from '../webCommands';

type SetClipboardContentParams = {
  textContent: string;
};

export class SetClipboardContent {
    public handle(params: SetClipboardContentParams): void {
        const clipboardElementId = 'clipboardElement';
        let $clipboardButton = $(`#${clipboardElementId}`);

        console.log('setting clipboard content', params.textContent);

        if (!ClipboardJs.isSupported()) {
            GameClient.getInstance().sendCommand(new OnErrorCommand({
                method: WebCommands.SET_CLIPBOARD_CONTENT,
                error: 'Copying to clipboard is not supported on your client'
            }));
            return;
        }

        if (!$clipboardButton.length) {
            const clipboardButton = $('<button>');

            clipboardButton.text('Test clipboard');
            clipboardButton.attr('id', clipboardElementId);
            clipboardButton.css('display', 'none');

            $('body').append(clipboardButton);
            $clipboardButton = clipboardButton;
        }

        $clipboardButton.attr('data-clipboard-text', params.textContent);
        $clipboardButton.attr('data-clipboard-action', 'copy');

        const clipboard = new ClipboardJs(`#${clipboardElementId}`);

        clipboard.on('error', (error: Error) => {
            console.error(error);
            GameClient.getInstance().sendCommand(new OnErrorCommand({
                method: WebCommands.SET_CLIPBOARD_CONTENT,
                error: error.message
            }));
        });

        $clipboardButton.click();
    }
}
